import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { NativeService } from 'src/service/native.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
declare var app;
@Component({
  selector: 'app-qc-customer-entry',
  templateUrl: './qc-customer-entry.component.html',
  styleUrls: ['./qc-customer-entry.component.scss']
})
export class QcCustomerEntryComponent extends GridBaseCase implements AfterViewInit   {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;

  orderID: string;
  baseObj: any = {};
  appHeight: any;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private native: NativeService,
    private com: CommonService,
    private baseService: BaseCase,
    public base: BaseModal,
    private inappbrowser: InAppBrowser
  ) {
    super();
    this.appHeight = {
      "background-color": "white",
      "min-height": window.innerHeight
    };
  }
 ngAfterViewInit()
 {
  this.baseService.FixedSubmitBtn.configName = "qcTagEntry";
  this.baseService.FixedSubmitBtn.isShow = true;
  // this.baseService.FixedSubmitBtn.text = "完成";
  this.baseService.FixedSubmitBtn.type = 8;
 }

  loadMoreData(event) {
    let that = this;
    this.LoadData(that.PageNumber);
  }


  LoadData(PageNumber) {
    let that = this;
    if(that.com.GetStorageKey("wxuserinfo")){
      that.baseObj = that.com.GetStorageKey("wxuserinfo");
      if(that.baseObj.b_TelPhone){
        that.baseObj.b_TelPhone=that.com.PhoneNum(that.baseObj.b_TelPhone);
      }
    }
  }

  //基本信息
  jbzlLoad() {
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    console.log("跳转页面");
    // that.orderID = "20191217170500004204";
    // that.orderID = "20191319081333230";
    // body.ConfigName="MemberManage";
    body.OpType = "get";
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.ConfigName = "GetOrderMemberInfo";
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    typeObj["a_OrderID"] = that.orderID;
    body.RequestBody = JSON.stringify(typeObj);

    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {

        that.baseObj = data.Status||{};
        // that.baseObj.c_ProductName = ["年复合士大夫撒", "圣诞节公安联合三", "施工法好带感", "傻哥哥大概", "更多桑的公积金三",]
        console.log("基本详情", this.baseObj);
        /****上拉加载数据end****/
      } else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
        // console.log(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }


  /**
   * 打开微信
   */
  Eventweixin() {
    console.log("打开微信");
    this.inappbrowser.create("weixin://");
  }


  EventLink(type: number) {
    if (type == 1) {
      this.com.Go("/tabs/contact/WCustomerDetail/view/" + this.baseObj.b_ID + "&" + this.com.getNowDatetime);
    }
    else {
      this.com.Go("/tabs/contact/HomeSFA/add/" + this.com.getNowDatetime);
    }
  }

  EventSubmitClick(type: number) {
    if (type == 1) {
      this.com.Go("/tabs/contact/WCustomerDetail/view/" + this.baseObj.b_ID + "&" + this.com.getNowDatetime);
    }
    else {
      this.com.Go("/tabs/contact/HomeSFA/add/" + this.com.getNowDatetime);
    }
  }

}
